export const GSTConstants = {

    POST_GST_REQUEST: 'POST_GST_REQUEST',
    POST_GST_SUCCESS: 'POST_GST_SUCCESS',
    POST_GST_FAILURE: 'POST_GST_FAILURE',

    POST_MUTIPLE_GST_REQUEST: 'POST_MUTIPLE_GST_REQUEST',
    POST_MUTIPLE_GST_SUCCESS: 'POST_MUTIPLE_GST_SUCCESS',
    POST_MUTIPLE_GST_FAILURE: 'POST_MUTIPLE_GST_FAILURE',

    POST_GST_DATA_REQUEST: 'POST_GST_DATA_REQUEST',
    POST_GST_DATA_SUCCESS: 'POST_GST_DATA_SUCCESS',
    POST_GST_DATA_FAILURE: 'POST_GST_DATA_FAILURE'
};